import { Injectable } from '@angular/core';
import { add_to_cart_interface, tiktokPixelEventType, tiktokPixelParamsModel } from './tiktok-pixel-model.model';



declare let ttq: any;



@Injectable({
  providedIn: 'root',
})
export class TiktokPixelService 
{


  currencyCode: string = '';


  constructor() {}


  generalEvent(event: tiktokPixelEventType, params: tiktokPixelParamsModel) 
  {
    if (typeof ttq !== 'undefined') {
      ttq.track( event, params);
    }
  }


  CompleteRegistration(content_id: any, name: any) 
  {
    if (typeof ttq !== 'undefined') {
      var CompleteRegistrationParams = {
        content_id,
        content_name: name,
        event_time: Date.now(), // Optional: Timestamp of the event
      };
      ttq.track('CompleteRegistration', CompleteRegistrationParams);
    }
  }


  AddToWishlist(content_id: any, name: any, price: any) 
  {
    if (typeof ttq !== 'undefined') {
      var AddToWishlistParams = {
        content_id,
        content_type: name,
        value: price,
        event_time: Date.now(), // Optional: Timestamp of the event
      };
      ttq.track('AddToWishlist', AddToWishlistParams);
    }
  }


  addToCart(addToCartParams: add_to_cart_interface) 
  {
    if (typeof ttq !== 'undefined') {
      ttq.track('AddToCart', addToCartParams);
    }
  }



  InitiateCheckout(
    id: any,
    name: any,
    price: any,
    description: any,
    cart: any
  ) 
  {
    if (typeof ttq !== 'undefined') {
      let contents = (cart as Array<any>).map((item) => {
        return {
          content_id: item.product.id,
          content_name: item.product.name,
          quantity: item.quantity,
          price: item.price,
        };
      });
      var InitiateCheckoutParams = {
        content_id: JSON.stringify(id),
        content_type: name,
        contents,
        description,
        currency: this.currencyCode,
        value: price,
        event_time: Date.now(), // Optional: Timestamp of the event
      };
      ttq.track('InitiateCheckout', InitiateCheckoutParams);
    }
  }



  PlaceAnOrder(
    id: any,
    name: any,
    price: any,
    quantity: any,
    description: any,
    cart: any
  ) 
  {
    if (typeof ttq !== 'undefined') {
      let contents = (cart as Array<any>).map((item) => {
        return {
          content_id: item.product.id,
          content_name: item.product.name,
          quantity: item.quantity,
          price: item.price,
        };
      });
      var PlaceAnOrderParams = {
        content_id: JSON.stringify(id),
        content_type: name,
        quantity,
        contents,
        description,
        currency: this.currencyCode,
        value: price,
        event_time: Date.now(), // Optional: Timestamp of the event
      };
      ttq.track('PlaceAnOrder', PlaceAnOrderParams);
    }
  }



  ViewContent(id: any, name: any, price: any, quantity: any, description: any) 
  {
    if (typeof ttq !== 'undefined') {
      var ViewContentParams = {
        content_id: JSON.stringify(id),
        content_type: name,
        quantity,
        description,
        currency: this.currencyCode,
        value: price,
        event_time: Date.now(), // Optional: Timestamp of the event
      };
      ttq.track('ViewContent', ViewContentParams);
    }
  }


  Subscribe() 
  {
    if (typeof ttq !== 'undefined') {
      var SubscribeParams = {
        event_time: Date.now(), // Optional: Timestamp of the event
      };
      ttq.track('Subscribe', SubscribeParams);
    }
  }


  SubmitForm() 
  {
    if (typeof ttq !== 'undefined') {
      var SubmitFormParams = {
        event_time: Date.now(), // Optional: Timestamp of the event
      };
      ttq.track('SubmitForm', SubmitFormParams);
    }
  }


  Search() 
  {
    if (typeof ttq !== 'undefined') {
      var SearchParams = {
        event_time: Date.now(), // Optional: Timestamp of the event
      };
      ttq.track('Search', SearchParams);
    }
  }


  Download() 
  {
    if (typeof ttq !== 'undefined') {
      var DownloadParams = {
        event_time: Date.now(), // Optional: Timestamp of the event
      };
      ttq.track('Download', DownloadParams);
    }
  }


  Contact() 
  {
    if (typeof ttq !== 'undefined') {
      var ContactParams = {
        event_time: Date.now(), // Optional: Timestamp of the event
      };
      ttq.track('Contact', ContactParams);
    }
  }


  ClickButton() 
  {
    if (typeof ttq !== 'undefined') {
      var ClickButtonParams = {
        event_time: Date.now(), // Optional: Timestamp of the event
      };
      ttq.track('ClickButton', ClickButtonParams);
    }
  }


  AddPaymentInfo()
  {
    if (typeof ttq !== 'undefined') {
      var AddPaymentInfoParams = {
        event_time: Date.now(), // Optional: Timestamp of the event
      };
      ttq.track('AddPaymentInfo', AddPaymentInfoParams);
    }
  }


  CompletePayment(
    id: any,
    name: any,
    price: any,
    quantity: any,
    description: any
  ) 
  {
    if (typeof ttq !== 'undefined') {
      var CompletePaymentParams = {
        content_id: JSON.stringify(id),
        content_type: name,
        quantity,
        description,
        currency: this.currencyCode,
        value: price,
        event_time: Date.now(), // Optional: Timestamp of the event
      };
      ttq.track('CompletePayment', CompletePaymentParams);
    }
  }
  


}
